import React, { useState } from "react";
import { Play, ArrowRight } from "lucide-react";
import { brokerOpens } from "../../blogData";
import VideoLightbox from "./VideoLightbox";

const BrokerFilms = () => {
  const [active, setActive] = useState(null);
  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 mt-20 space-y-16" data-testid="broker-films">
      {brokerOpens.map((b, i) => (
        <div key={b.id} className={`grid gap-10 md:gap-16 items-center ${i % 2 ? "md:grid-cols-[1fr_1.4fr]" : "md:grid-cols-[1.4fr_1fr]"}`}>
          <button
            data-testid={`broker-video-${b.id}`}
            onClick={() => setActive(b.video)}
            className={`group relative overflow-hidden bg-black w-full ${b.orientation === "portrait" ? "aspect-[9/16] max-w-[360px] mx-auto md:mx-0" : "aspect-video"} ${i % 2 ? "md:order-2" : ""}`}
          >
            <video className="w-full h-full object-cover" autoPlay loop muted playsInline preload="metadata">
              <source src={b.video} type="video/mp4" />
            </video>
            <div className="absolute inset-0 bg-black/15 group-hover:bg-black/35 transition-colors flex items-center justify-center">
              <span className="w-16 h-16 rounded-full bg-[#b4936a]/85 text-white flex items-center justify-center group-hover:scale-110 group-hover:bg-[#b4936a] transition-all duration-300"><Play size={22} className="ml-1" /></span>
            </div>
          </button>
          <div className={`reveal ${i % 2 ? "md:order-1" : ""}`}>
            <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-4">{b.location}</p>
            <h2 className="font-serif-display text-3xl md:text-5xl font-light text-[#1a1a1a] mb-5">{b.title}</h2>
            <p className="text-neutral-500 text-[15px] leading-relaxed max-w-md">{b.blurb}</p>
            <button onClick={() => setActive(b.video)} className="inline-flex items-center gap-2 mt-6 text-[11px] tracking-luxe uppercase text-[#1a1a1a] border-b border-[#1a1a1a] pb-1 hover:text-[#b4936a] hover:border-[#b4936a] transition-colors">Watch the Film <ArrowRight size={14} /></button>
          </div>
        </div>
      ))}
      <VideoLightbox src={active} onClose={() => setActive(null)} />
    </div>
  );
};

export default BrokerFilms;
